import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main-nav" }

import { computed, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import { AppStore } from '@/store';
import FaIcon from '@/core/components/FaIcon.vue';
import { getValueInUserLanguage } from '../languageContent';
import auth from '@/core/Auth';
import { CmsPage } from '@/modules/cms_page/CmsPage';


export default /*@__PURE__*/_defineComponent({
  __name: 'TheMainNavigation',
  setup(__props) {

const store = useStore<AppStore>();
const authUser = computed(() => store.state.authenticatedUser);
const isPartnerUser = computed(() => authUser.value?.partner !== undefined);
const isCustomerUser = computed(() => authUser.value?.customer !== undefined);
const cmsPages = computed<CmsPage[]>(() => {
	if (authUser.value?.type === 'MASTER') {
		return [];
	}

	return store.getters.cmsPages;
});
const can = auth.can;
const canAny = auth.canAny;

onBeforeMount(() => {
	store.dispatch('loadCmsPages');
});

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_RouterLink, { to: {name: 'dashboard'} }, {
      default: _withCtx(() => [
        _createVNode(FaIcon, { icon: "home" }),
        _createVNode(_component_translate, null, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("Start", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_unref(can)('USER'))
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 0,
          to: {name: 'user.index'}
        }, {
          default: _withCtx(() => [
            _createVNode(FaIcon, { icon: "user" }),
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("Användare", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(can)('CUSTOMER'))
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 1,
          to: {name: 'customer.index'}
        }, {
          default: _withCtx(() => [
            _createVNode(FaIcon, { icon: "chart-network" }),
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("Kunder", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(canAny)(['PARTNER', 'PARTNER_WHITELABEL']))
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 2,
          to: {name: 'partner.index'}
        }, {
          default: _withCtx(() => [
            _createVNode(FaIcon, { icon: "users-class" }),
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("Återförsäljare", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(can)('LAW_FIRM_EDIT'))
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 3,
          to: {name: 'law_firm.index'}
        }, {
          default: _withCtx(() => [
            _createVNode(FaIcon, { icon: "handshake-alt" }),
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Externa partners", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (isPartnerUser.value && _unref(can)('LAW_FIRM_CREATE'))
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 4,
          to: {name: 'partner.me.law_firm'}
        }, {
          default: _withCtx(() => [
            _createVNode(FaIcon, { icon: "handshake-alt" }),
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("Extern partner", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(can)('NEWS'))
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 5,
          to: {name: 'news.index'}
        }, {
          default: _withCtx(() => [
            _createVNode(FaIcon, { icon: "newspaper" }),
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("Nyheter", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(can)('CMS_PAGE'))
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 6,
          to: {name: 'cmsPage.index'}
        }, {
          default: _withCtx(() => [
            _createVNode(FaIcon, { icon: "file" }),
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("CMS-sidor", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(can)('PRODUCT'))
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 7,
          to: {name: 'product.index'}
        }, {
          default: _withCtx(() => [
            _createVNode(FaIcon, { icon: "envelope-open-dollar" }),
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("Produkter", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(can)('TICKET_CATEGORY'))
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 8,
          to: {name: 'ticket_category.index'}
        }, {
          default: _withCtx(() => [
            _createVNode(FaIcon, { icon: "folder-tree" }),
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("Ärendekategorier", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(can)('TICKET_STATUS'))
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 9,
          to: {name: 'ticket_status.index'}
        }, {
          default: _withCtx(() => [
            _createVNode(FaIcon, { icon: "heart-rate" }),
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode("Ärendestatusar", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(canAny)(['TICKET', 'TICKET_ASSIGN']))
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 10,
          to: {name: 'ticket.index'}
        }, {
          default: _withCtx(() => [
            _createVNode(FaIcon, { icon: "whistle" }),
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode("Ärenden", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (isCustomerUser.value)
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 11,
          to: {name: 'customer.ticketform'}
        }, {
          default: _withCtx(() => [
            _createVNode(FaIcon, { icon: "link" }),
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode("Rapportformulär", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cmsPages.value, (cmsPage) => {
      return (_openBlock(), _createBlock(_component_RouterLink, {
        key: cmsPage.id,
        to: {
				name: 'cmsPage.view',
				params: {
					id: cmsPage.id,
				},
			}
      }, {
        default: _withCtx(() => [
          _createVNode(FaIcon, { icon: "file-alt" }),
          _createTextVNode(" " + _toDisplayString(_unref(getValueInUserLanguage)(cmsPage.content, 'headline')), 1)
        ]),
        _: 2
      }, 1032, ["to"]))
    }), 128))
  ]))
}
}

})